module.exports = __webpack_public_path__ + "static/img/logo-tb.ac43e5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-tb.png
// module id = VzYB
// module chunks = 1